import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { AuthFrame, authField, authLabel, authButton } from "@/components/admin/AuthFrame";
import { api, apiError } from "@/lib/api";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data?.message || "If that email belongs to the admin, a reset link is on its way.");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthFrame testid="admin-forgot-page" eyebrow="Forgot password" title="Reset password">
      {sent ? (
        <div data-testid="forgot-sent" className="mt-8 border-l-2 border-[#FF5A00] bg-white p-5">
          <MailCheck className="h-6 w-6 text-[#FF5A00]" />
          <p className="mt-3 text-base">{sent}</p>
          <p className="mt-2 text-sm text-zinc-600">Check your inbox (and spam folder). The link expires in 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} data-testid="admin-forgot-form">
          <p className="mt-4 text-sm text-zinc-700">Enter the admin email and we'll send you a link to choose a new password.</p>
          <label className={`${authLabel} mt-8`} htmlFor="email">Admin email</label>
          <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className={`${authField} mt-2`} />
          {error && <p data-testid="forgot-error" className="mt-4 border-l-2 border-red-600 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
          <button type="submit" disabled={busy} data-testid="forgot-submit" className={authButton}>
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Send reset link
          </button>
        </form>
      )}
      <Link to="/admin/login" data-testid="forgot-back-login" className="mt-6 inline-block font-mono text-xs uppercase tracking-[0.15em] text-zinc-700 underline-offset-4 hover:underline">Back to sign in</Link>
    </AuthFrame>
  );
}
